export default __webpack_public_path__ + "static/media/ic_checked.ef61d0e2.svg";